import CryptoJS from "crypto-js";
import { CRYPTO_KEY } from "./constants";
const SECRET_KEY: any = CRYPTO_KEY;

export const StorageBox = {
  getAccessToken: () => {
    const encryptedData = localStorage.getItem("access_token");
    if (encryptedData !== null) {
      const decryptedData = CryptoJS.AES.decrypt(
        encryptedData,
        SECRET_KEY,
      ).toString(CryptoJS.enc.Utf8);
      return decryptedData;
    }
    return null;
  },
  getRefreshToken: () => {
    const encryptedData = localStorage.getItem("refresh_token");
    if (encryptedData !== null) {
      const decryptedData = CryptoJS.AES.decrypt(
        encryptedData,
        SECRET_KEY,
      ).toString(CryptoJS.enc.Utf8);
      return decryptedData;
    }
    return null;
  },
  getTokenExpiry: () => localStorage.getItem("access_token_expires_at"),
  saveAccessToken: (token: any) => {
    const encryptedData = CryptoJS.AES.encrypt(token, SECRET_KEY).toString();
    localStorage.setItem("access_token", encryptedData);
  },
  saveRefreshToken: (token: any) => {
    const encryptedData = CryptoJS.AES.encrypt(token, SECRET_KEY).toString();
    localStorage.setItem("refresh_token", encryptedData);
  },
  saveTokenExpiry: (expiresAt: string) => {
    localStorage.setItem("access_token_expires_at", expiresAt);
  },
  saveWalletId: (item: any) => {
    const encryptedData = CryptoJS.AES.encrypt(item, SECRET_KEY).toString();
    localStorage.setItem("walletId", encryptedData);
  },
  getWalletId: () => {
    const encryptedData = localStorage.getItem("walletId");
    if (encryptedData !== null) {
      const decryptedData = CryptoJS.AES.decrypt(
        encryptedData,
        SECRET_KEY,
      ).toString(CryptoJS.enc.Utf8);
      return decryptedData;
    }
    return null;
  },
  saveUserData: (data: any) => {
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      SECRET_KEY,
    ).toString();
    localStorage.setItem("userData", encryptedData);
  },
  retrieveUserData: () => {
    const encryptedData = localStorage.getItem("userData");
    if (encryptedData !== null) {
      const decryptedData = JSON.parse(
        CryptoJS.AES.decrypt(encryptedData, SECRET_KEY).toString(
          CryptoJS.enc.Utf8,
        ),
      );
      // console.log(decryptedData);
      return decryptedData;
    } else {
      return null;
    }
  },
  clearStorage: () => {
    // Keep the theme choice across sign-outs.
    const darkMode = localStorage.getItem("darkMode");
    localStorage.clear();
    if (darkMode !== null) localStorage.setItem("darkMode", darkMode);
  },
};
